const mailTo = ({ email, subject = '', body = '' }) => {
    let params = subject || body ? '?' : '';
    if (subject)
        params += `subject=${encodeURIComponent(subject)}`;
    if (body)
        params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject) || ''}&body=${encodeURIComponent(body) || ''}`;
};
export default mailTo;
